"use client";
import styles from "./StepInput.module.css";
import { useEffect, useRef } from "react";
import { Check, InfoIcon } from "lucide-react";

const StepInput = ({
  type = "text",
  inputMode = "text",
  label,
  value,
  onChange,
  error,
  placeholder,
  autoComplete = "off",
  autoCorrect = "off",
  name,
  required = false,
  maxLength,
  minLength,
  autoFocus = false,
  helpText,
  onBlur,
  onFocus,
  onKeyDown,
  isDesktop = false,
  iconLeft,
  paddingRight = "clamp(50px, 4vh, 50px)",
  paddingLeft = "clamp(50px, 4vh, 50px)",
  colorText = "white",
}) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (autoFocus && inputRef.current) {
      setTimeout(() => inputRef.current?.focus(), 50);
    }
  }, [autoFocus]);

  return (
    <div
      className="space-y-2 w-full"
      style={{
        paddingRight: isDesktop && paddingRight,
        paddingLeft: isDesktop && paddingLeft,
      }}
    >
      <div className="flex justify-between">
        {label && (
          <span
            className="font-semibold2 flex"
            style={{ fontSize: "16px", marginBottom: "8px", color: colorText }}
          >
            {label}
          </span>
        )}

        {maxLength && (
          <p className="text-sm text-metal text-end">
            {value ? value.length : 0} / {maxLength}
          </p>
        )}
      </div>

      <div
        className={`flex items-center px-3 py-2 border transition-all rounded-xl border-purple
        ${error && "border-red border-2"}
      `}
        style={{
          backgroundColor: value
            ? "#565584"
            : isDesktop
              ? "#1C1535"
              : "#2C2447",
          borderRadius: "8px",
          border:
            error || value ? "2px solid #C9B8FF" : "2px solid transparent",
            marginTop: "0px"
        }}
      >
        {iconLeft && (
          <span
            style={{
              color: value ? "#C9B8FF" : "#687099",
            }}
          >
            {iconLeft}
          </span>
        )}
        <input
          ref={inputRef}
          type={type}
          name={name}
          inputMode={inputMode}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          onFocus={onFocus}
          onKeyDown={onKeyDown}
          maxLength={maxLength}
          max={maxLength}
          minLength={minLength}
          min={minLength}
          placeholder={placeholder}
          autoComplete={autoComplete}
          autoCorrect={autoCorrect}
          spellCheck="false"
          className={`
            w-full
            bg-transparent
            border-none
            outline-hidden
            py-2
            text-xl
            placeholder:text-metal
            ${styles.input}
          `}
          style={{
            boxShadow: "none",
            color: error ? "red" : "#C9B8FF",
          }}
        />
        <Check
          className="w-8 h-8 text-purple"
          style={{
            color: value ? "#C9B8FF" : "#687099",
          }}
          strokeWidth={2.5}
        />
      </div>

      {error && (
        <div className="flex flex-row items-center gap-3 ">
          <InfoIcon className="w-5 h-5 text-red" />
          <p className=" text-red" style={{ fontSize: "15px" }}>
            {error}
          </p>
        </div>
      )}
    </div>
  );
};

export default StepInput;
